import { configureStore } from '@reduxjs/toolkit';
import themeReducer from './common/reducers/theme/theme-reducer';
import visiblePageReducer from './common/reducers/visible-page/visible-page-reducer';
import timelineReducer from './components/Timeline/timeline-reducer';
import youtubeReducer from './common/reducers/youtube/youtube-reducer';
var store = configureStore({
    reducer: {
        theme: themeReducer,
        timeline: timelineReducer,
        visibilePage: visiblePageReducer,
        youtube: youtubeReducer,
    },
});
export default store;
